module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Black.49c7c1f6.woff";